angular
  .module('washesRevenue')
  .component('washesRevenue', {
    template: require('./washes-revenue.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function WashRevenueController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $rootScope.mainmenu = 'washes';
        $rootScope.menu = 'washRevenue';
        $scope.doLogout = $rootScope.doLogout;
        this.loginMember = $rootScope.loginMember;
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isLevel2Authenticated()) {
          $location.path('/login');
          return;
        }
        $resource(`${APIURL}/admin/stat/revenue`).get({}, (data) => {
          this.revenues = data.revenues;
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/washes-revenue/washes-revenue.component.js